import * as Yup from 'yup';

const schema = Yup.object().shape({
    industriaId: Yup.string().required('Selecione uma opção'),
});

export default schema;